import React, { useEffect, useState } from 'react'
import { useParams, useLocation, useHistory } from 'react-router-dom'

import ViewerDocument from '../../shared/components/ViewerDocument/ViewerDocument'
import { useAlert } from '../../shared/components/Alert'
import usePolicyClient from '../../clients/PolicyClient/usePolicyClient'

const SalesForceDocumentViewer = () => {
  const policyClient = usePolicyClient()

  const { tipoDocumento, numeroApolice } = useParams()
  const { search } = useLocation()
  const { addMsgDanger } = useAlert()
  const history = useHistory()
  const [documentData, setDocumentData] = useState('')

  useEffect(() => {
    const token = new URLSearchParams(search).get('token')

    policyClient().getSalesForceDocument(tipoDocumento, {
      numeroApolice,
      token,
      base64: true,
    }).then((response) => {
      setDocumentData(response.data)
    }, (error) => {
      let msg = 'Nenhum documento encontrado.'

      if (error.status !== 404) {
        msg = 'Não foi possível buscar o documento no momento.'
      }

      addMsgDanger({
        message: msg,
        action: () => {
          history.push('/')
        },
      })
    })
  }, [tipoDocumento, numeroApolice, search, policyClient, addMsgDanger, history])

  return (
    <>
      {documentData !== '' && (
        <ViewerDocument documentBase64={documentData} />
      )}
    </>
  )
}

export default SalesForceDocumentViewer
